// import TarefaMobilidadePage from './pages/TarefaMobilidadePage.vue'
import TarefaMobilidadeAssociacaoPage from './pages/TarefaMobilidadeAssociacaoPage.vue'
import MobilidadeMetodoAssociacaoPage from './pages/MobilidadeMetodoAssociacaoPage.vue'
import TarefaMobilidadeAbas from './pages/TarefaMobilidadeAbas'
import TarefaOpcaoTratativaAssociacaoPage from './pages/TarefaOpcaoTratativaAssociacaoPage'

const routes = [
  {
    path: 'tarefas-mobilidades',
    name: 'tarefas-mobilidades',
    component: TarefaMobilidadeAbas
  },
  {
    path: 'tarefas-mobilidades/:tarefa',
    name: 'tarefas-mobilidades-associacao',
    component: TarefaMobilidadeAssociacaoPage
  },
  {
    path: 'tarefas-mobilidades-metodos/:ctrl_tarefa_mobilidade',
    name: 'tarefas-mobilidades-metodos-associacao',
    component: MobilidadeMetodoAssociacaoPage
  },
  {
    path: 'tarefas-opcoes-tratativas/:tarefa',
    name: 'tarefas-opcoes-tratativas-associacao',
    component: TarefaOpcaoTratativaAssociacaoPage
  },
];

export default routes;